// Add function to the window, so it is globally available
window.remove_notifications = remove_notifications;

// Remove the notification functionality
function remove_notifications() {

	// Remove notification after clicking on its close button
	document.querySelectorAll( 'div.component.push-notification > .component.button.close' ).forEach( close_button => {
		close_button.addEventListener( "click", function( event ) {
			// On click remove parent push-notification element
			this.parentElement.remove();
		});
	});

	// Automatically remove all the push notification element after 5 seconds
	setTimeout( function() {
		document.querySelectorAll( '.component.push-notification' ).forEach( push_notification_element => {
			push_notification_element.remove();
		});
	}, 5000);
}